import { SeoData, HeaderImage, MoreInfoButton } from "components";
import { Link } from "react-router";
import styles from '../Home.module.css';
import underline from 'assets/images/misc/underline-decorative-graphic_9.6.26.webp';
import verifiedFeaturesImage from 'assets/images/verification/verified-features-image-needs-redesign_9.6.26.webp';
import verifiedBadgeVariant2 from 'assets/images/misc/verified-badge-usync-verified-variant2_9.6.26.webp';

export const Verification = () => {
    return (
        <div className="standardContainer">
            <SeoData
                title={"Verification"}
                description="Own a league, LAN, or tournament website on uSync - become uSync Verified to promote your event and prove your reputability in the esports scene."
                canonicalPath={"/more/verification"}
            />
            <HeaderImage title={""} verification={true} imageClass={"verificationPage"} />

            <div className={styles.sectionTwo}>
                <h2 className={styles.white}>Verified Features</h2>
                <img className={"underlineImg"} src={underline} alt="underline" />

                <div className={styles.subscriptionContainer}>
                    <Link to={"https://buy.stripe.com/eVadRz4PY0s31mEcMV"} target="_blank">
                        <img src={verifiedFeaturesImage} alt="Verified Features" />
                    </Link>
                </div>

                <div className="hr" />

                <div className={styles.subscriptionContainer}>
                    <img className={styles.usyncVerified} src={verifiedBadgeVariant2} alt="uSync Verified" />
                    <img className={"underlineImg"} src={underline} alt="underline" />

                    <h1 className={styles.verificationDesc}>
                        uSync Verified providers are the most trustworthy providers that we feature. 
                        These events are not only extremely well trusted but have shown a record of exceptional quality in their work. 
                        We strive to verify as many events as possible so that you can bring your organization to the highest level of competitive play.
                    </h1>
                
                </div>

                <div className="hr" />

                <p className={`${styles.learn} ${styles.post}`}>
                    Looking to post an event? Send {" "}
                    <Link to={"/more/eventhost"}>Event Submission</Link>
                </p>

            </div>
        </div>
    );
}
